import { Component, Input } from '@angular/core';


/**
 * Component that depicts a bearing in degrees as a triangular arrow.
 */
@Component({
  selector: 'app-bearing',
  templateUrl: './bearing.component.html',
  styleUrls: ['./bearing.component.scss']
})
export class BearingComponent {
  baseWidth = 4;
  baseHeight = 10;

  /**
   * Bearing in degrees
   */
  @Input() bearing: number;

  /**
   * Arrow color (any valid HTML color)
   */
  @Input() color = 'black';

  /**
   * Multiplier used to control the size of the arrow (1 by default)
   */
  @Input() scale = 1;

  get style(): any {
    return {
      transform: `rotate(${this.bearing}deg)`,
      borderTopColor: `${this.color}`,
      borderTopWidth: `${this.scale * this.baseHeight}px`,
      borderLeftWidth: `${this.scale * this.baseWidth}px`,
      borderRightWidth: `${this.scale * this.baseWidth}px`
    };
  }
}
